module.exports = __webpack_public_path__ + "img/background2.9331c492.jpg";